import { useWatch } from "react-hook-form";
import SBWarning from "../../MDDForm/Controls/SBWarning.jsx";
import { useFormCoverage } from "../FormDefinitionRenderer/contexts.js";

export default function SBWarningControl({ item }) {
  const { objektSparten } = useFormCoverage();
  const values = useWatch();
  const sparteObj = objektSparten.find(
    (objektSparte) => objektSparte.sparte_id === values.sparte_id
  );
  return <SBWarning item={item} sparteObj={sparteObj} values={values} />;
}
